'use strict';

var React = require('react');

var SvgReceiptEuroFilledIcon = function SvgReceiptEuroFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.142 16.934a1 1 0 0 1-.642-.934v-11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v11a1 1 0 0 1-1.743.669l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.486 0l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.101.265Zm4.882-9.939c-.321.193-.728.692-.846 1.755h2.347a.75.75 0 0 1 0 1.5h-2.318c.146.945.526 1.459.857 1.688.406.28.83.22 1.116-.065a.75.75 0 1 1 1.06 1.06c-.82.82-2.053.912-3.028.239-.801-.553-1.356-1.556-1.518-2.922h-.194a.75.75 0 0 1 0-1.5h.172c.128-1.467.702-2.514 1.58-3.041 1.007-.604 2.21-.39 2.989.389a.75.75 0 1 1-1.061 1.06c-.327-.326-.781-.388-1.156-.163Z"
  }));
};
SvgReceiptEuroFilledIcon.displayName = "ReceiptEuroFilledIcon";

exports.SvgReceiptEuroFilledIcon = SvgReceiptEuroFilledIcon;
